import { createBooleanFeatureFlag, createFeatureFlagConfig, createRemoteFeatureFlag } from './featureFlags.factories';

export const FEATURE_FLAG_VALUES = {
  layout: createFeatureFlagConfig('layout', ['aloha', 'brannan']),
  guestsitetarget: createFeatureFlagConfig('guestsitetarget', ['bliss', 'charm']),
  nossr: createBooleanFeatureFlag('nossr'),
  joyWeb: createFeatureFlagConfig('joy-web', true),
  pseudoLocalization: createFeatureFlagConfig('pseudoloc', ['true', 'all']),
  bookmarkletPopup: createBooleanFeatureFlag('bookmarkletPopup'),
  enableSsr: createBooleanFeatureFlag('enablessr'),
  doRegistryOnboardingCardsReset: createBooleanFeatureFlag('doRegistryOnboardingCardsReset'),
  registryEnableGuestNavRegistryLinks: createRemoteFeatureFlag({ key: 'registryEnableGuestNavRegistryLinks', supportedValues: ['on', 'off'] }),
  registryShowStandalonePageTitle: createRemoteFeatureFlag({ key: 'registryShowStandalonePageTitle', supportedValues: ['on', 'off'] }),
  registryOnboardingSurvey: createFeatureFlagConfig('registryOnboardingSurvey', ['force', 'reset', 'force5']),
  registryOnboardingV3Experiment: createRemoteFeatureFlag({
    key: 'registryOnboardingV3Experiment',
    supportedValues: ['control', 'treatment'],
  }),
  enableRegistryTransfer: createBooleanFeatureFlag('enableRegistryTransfer', true),
  enableHaveYouPurchasedModal: createBooleanFeatureFlag('enableHaveYouPurchasedModal', true),
  enableHaveYouPurchasedModalExternalLinkClick: createBooleanFeatureFlag('enableHaveYouPurchasedModalExternalLinkClick', true),
  enableCashFundCheckoutV2: createBooleanFeatureFlag('enableCashFundCheckoutV2', true),
  enableLoadingStyleApplicator: createBooleanFeatureFlag('enableLoadingStyleApplicator'),
  enableAddressVerificationModal: createBooleanFeatureFlag('enableAddressVerificationModal'),
  enableAddEditGiftNote: createBooleanFeatureFlag('enableAddEditGiftNote', true),
  enableCurationHomeExpert: createBooleanFeatureFlag('enableCurationHomeExpert', true),
  enableBuyForMyselfFromPurchaseConfirmation: createBooleanFeatureFlag('enableBuyForMyselfFromPurchaseConfirmation', true),
  enableRandomLabelsGuestRegistryProducts: createBooleanFeatureFlag('enableRandomLabelsGuestRegistryProducts'),
  enableSplitPurchaseDialog: createBooleanFeatureFlag('enableSplitPurchaseDialog', true),
  enableShippingAddressWarning: createBooleanFeatureFlag('enableShippingAddressWarning', true),
  orderTrackingFeature: createBooleanFeatureFlag('orderTrackingFeature', true),
  enableMFASettings: createBooleanFeatureFlag('enableMFASettings', true),
  enableAffiliateCheckoutV2: createBooleanFeatureFlag('enableAffiliateCheckoutV2', true),
  enableNewExternalRegistry: createBooleanFeatureFlag('enableNewExternalRegistry'),
  enableChecklistInGiftBasketWidget: createBooleanFeatureFlag('enableChecklistInGiftBasketWidget', true),
  enableBlankDates: createBooleanFeatureFlag('enableBlankDates', true),
  enableCustomEventName: createBooleanFeatureFlag('enableCustomEventName', true),
  enableBabyRegistry: createBooleanFeatureFlag('enableBabyRegistry', true),
  enableExternalRegistriesForBabyReg: createBooleanFeatureFlag('enableExternalRegistriesForBabyReg', true),
  enableBabyRegistrySoftLaunchFeatures: createBooleanFeatureFlag('enableBabyRegistrySoftLaunchFeatures', true),
  seamlessCheckoutVariant: createRemoteFeatureFlag({ key: 'wgseamlesscheckout', supportedValues: ['variant1', 'variant2', 'variant3'] }),
  joyRefundsEnabled: createRemoteFeatureFlag({ key: 'joyrefundsenabled', supportedValues: ['on', 'off'] }),
  guestLinkUseRedirectService: createRemoteFeatureFlag({ key: 'guestlinkuseredirectservice', supportedValues: ['on', 'off'] }),
  // Kill switch for the /account/events `eventUsersPaginated` swap; off = the single unpaginated `eventUsers` fetch.
  accountEventsPagination: createRemoteFeatureFlag({ key: 'accounteventspagination', supportedValues: ['on', 'off'] }),
  enableInlineEditing: createBooleanFeatureFlag('enableInlineEditing', false),
  isMobileInlineEditMode: createBooleanFeatureFlag('isMobileInlineEditMode', false),
  supportAutocompletePreDefinedPlacesEnabled: createRemoteFeatureFlag({ key: 'supportAutocompletePreDefinedPlacesEnabled', supportedValues: ['on', 'off'] }),
  websiteBannerMapping: createRemoteFeatureFlag('websitebannermapping'),
  rsvpEnableAccommodationsRedirect: createRemoteFeatureFlag({ key: 'rsvpenableaccommodationsredirect', supportedValues: ['control', 'treatment'] }),
  enableRegistryRedirectInMessaging: createRemoteFeatureFlag('enableRegistryRedirectInMessaging'),
  messageDraftsEnabled: createRemoteFeatureFlag({ key: 'messagedraftsenabled', supportedValues: ['on', 'off'] }),
  messageSchedulingEnabled: createRemoteFeatureFlag({ key: 'messageschedulingenabled', supportedValues: ['on', 'off'] }),
  /** Gates the Share Stay Reminder admin composer and its messaging hub tile. */
  shareStayReminderEnabled: createRemoteFeatureFlag({ key: 'sharestayreminderenabled', supportedValues: ['on', 'off'], defaultValue: 'off' }),
  /**
   * MSG-284: the premium card bridge and its kill switch. Redirects the Cards send screen to the General composer, which
   * opens the card from `?stationeryOrderNumber=`. It answers "is this phase live" only, so never target it on a segment
   * signal: `isGeneralOrCarbon` owns that question. A missing, loading, or failed read is `off`.
   */
  premiumCardMessagingBridgeEnabled: createRemoteFeatureFlag({ key: 'premiumcardmessagingbridgeenabled', supportedValues: ['on', 'off'], defaultValue: 'off' }),
  /**
   * Gates the in-app Stripe payout bank-account editor (Connect 'account-management' embedded
   * component). Off means couples keep only the Express Dashboard link. See NREG-3351.
   */
  enableEmbeddedPayoutManagement: createRemoteFeatureFlag({ key: 'enableembeddedpayoutmanagement', supportedValues: ['on', 'off'], defaultValue: 'off' }),
  newCashFundsEnabled: createRemoteFeatureFlag('newCashFundsEnabled'),
  websiteCashFundComponentEnabled: createRemoteFeatureFlag('websiteCashFundComponentEnabled'),
  websiteCashFundsi18nEnabled: createRemoteFeatureFlag('websiteCashFundsi18nEnabled'),
  // Gates the publish flow behind email verification. When 'on', publishing opens the
  // email verification dialog for unverified users; when 'off', publish proceeds as before.
  publishEmailVerificationEnabled: createRemoteFeatureFlag({ key: 'publishemailverificationenabled', supportedValues: ['on', 'off'], defaultValue: 'off' }),
  weddingGeneralMessagingEnabled: createRemoteFeatureFlag('weddingGeneralMessagingEnabled'),
  /** Compose-time intent detection in General Messaging — surfaces a Cash Funds nudge when the draft semantically asks for money. See NREG-3133 + `joy-web/.claude/plans/message-detector.md`. */
  messageIntentDetectionEnabled: createRemoteFeatureFlag('messageIntentDetectionEnabled'),
  /**
   * Gates the RSVP admin Results "By Lodging" tab (hotels -> their booked guests, reusing the
   * Accommodations booking tracker's by-lodging view). LEGRSVP-72.
   */
  rsvpByLodgingTabEnabled: createRemoteFeatureFlag({
    key: 'rsvpByLodgingTabEnabled',
    supportedValues: ['on', 'off'],
  }),
  /** Gates the attendance-question "Events" control that links RSVP questions to Schedule-page events. */
  rsvpLinkedEventsEnabled: createRemoteFeatureFlag({
    key: 'rsvpLinkedEventsEnabled',
    supportedValues: ['on', 'off'],
  }),
  /** Gates the RSVP question type/category row and the Meal question's schedule-item control. PRO-431. */
  rsvpMealQuestionsEnabled: createRemoteFeatureFlag({
    key: 'rsvpMealQuestionsEnabled',
    supportedValues: ['on', 'off'],
    defaultValue: 'off',
  }),
  /** Gates the RSVP Plus paid tier surfaces: locked/unlocked Plus settings section, upsell dialog + checkout, and the superadmin tier select. LEGRSVP-66. */
  rsvpPlusEnabled: createRemoteFeatureFlag({
    key: 'rsvpPlusEnabled',
    supportedValues: ['on', 'off'],
  }),
  /** Gates the Seating Chart entry points (dashboard Guest List menu → /edit/seatingchart). SEAT-158. */
  seatingChartEnabled: createRemoteFeatureFlag({
    key: 'seatingchartenabled',
    supportedValues: ['on', 'off'],
  }),

  /**
   * Is being AB tested
   */
  // this is a long-lived flag; the Feature is only shown to UK Couples, a filter powered entirely by Amplitude
  cambiumGroupRegistryReferralsEnabled: createRemoteFeatureFlag('cambiumGroupRegistryReferralsEnabled'),
  universalCatalogSearchEnabled: createRemoteFeatureFlag('universalCatalogSearchEnabled'),
  universalCatalogMeshExperiment: createRemoteFeatureFlag({
    key: 'universalCatalogMeshExperiment',
    supportedValues: ['control', 'low-volume-google-shopping-first', 'low-volume-joy-catalog-first', 'joy-catalog-first'],
  }),
  websiteWeatherReportEnabled: createRemoteFeatureFlag('websiteWeatherReportEnabled'),
  // The Amplitude key must stay all-lowercase: createRemoteFeatureFlag lowercases the lookup, and
  // Amplitude keys its variant map by the flag's own casing, so a camelCase flag silently resolves
  // to its default forever.
  websitePageScheduleEnabled: createRemoteFeatureFlag({
    key: 'websitepagescheduleenabled',
    supportedValues: ['on', 'off'],
    defaultValue: 'off',
  }),
  registryCompactDonationViewEnabled: createRemoteFeatureFlag({
    key: 'registryCompactDonationViewEnabled',
    supportedValues: ['on', 'off'],
    defaultValue: 'off',
  }),

  /* things to do experiments */
  websiteThingsToDoLayoutExperiment: createRemoteFeatureFlag({ key: 'websiteThingsToDoLayoutExperiment', supportedValues: ['clean', 'modal', 'links', 'off'] }),
  honeymoonPlanningExperiment: createRemoteFeatureFlag({ key: 'honeymoonPlanningExperiment', supportedValues: ['on', 'off'] }),
  /** Kill switch for all cash fund partner placements. Remove a variant value to disable that partner globally across all placements. */
  activeCashFundPartner: createRemoteFeatureFlag({ key: 'activeCashFundPartner', supportedValues: ['ally', 'chase', 'revolut'] }),
  /** Placement: create-fund dialog (`CreateFundDialog`). Gated with activeCashFundPartner. */
  enableCashFundPartnerCreateFundDialog: createRemoteFeatureFlag({ key: 'enableCashFundPartnerCreateFundDialog', supportedValues: ['ally', 'chase'] }),
  /** Placement: registry admin gift tracker empty state (`AllyBanner`). Gated with activeCashFundPartner. */
  enableCashFundPartnerGiftTracker: createRemoteFeatureFlag({ key: 'enableCashFundPartnerGiftTracker', supportedValues: ['ally', 'chase'] }),
  /** Placement: Cash Funds shop nav dropdown (4th panel) + Cash Funds dept page (first carousel tile). Gated with activeCashFundPartner. */
  enableCashFundPartnerShop: createRemoteFeatureFlag({ key: 'enableCashFundPartnerShop', supportedValues: ['ally', 'chase'] }),
  /** Placement: transfer-to-bank dialog (`TransferToBankDialogView`). Gated with activeCashFundPartner. */
  enableCashFundPartnerTransferToBank: createRemoteFeatureFlag({ key: 'enableCashFundPartnerTransferToBank', supportedValues: ['ally', 'chase', 'revolut'] }),
  /** Placement: transfer-to-bank dialog repeat nudge shown when bank is already connected (pending/confirm state). Gated with activeCashFundPartner. */
  enableCashFundPartnerTransferToBankRepeat: createRemoteFeatureFlag({ key: 'enableCashFundPartnerTransferToBankRepeat', supportedValues: ['ally', 'chase', 'revolut'] }),
  /**
   * Prevent using cached SSR html.
   */
  skipSsrCache: createBooleanFeatureFlag('skipssrcache'),
  logSsrUserAgent: createBooleanFeatureFlag('logSsrUserAgent'),

  exampleOnOffRemoteFeatureFlag: createRemoteFeatureFlag('exampleOnOffFeatureFlag'),
  exampleMultiVariantRemoteFeatureFlag: createRemoteFeatureFlag({ key: 'examplemultivariantfeatureflag', supportedValues: ['variant1', 'variant2'], defaultValue: 'variant1' }),
  exampleExperimentFeatureFlag: createRemoteFeatureFlag({ key: 'exampleexperimentfeatureflag', supportedValues: ['control', 'treatment'] }),
  exampleExperimentBucketedByJoyEvent: createRemoteFeatureFlag({ key: 'exampleexperimentbucketedbyjoyevent', supportedValues: ['control', 'treatment'] }),
  adminDashboardOverviewFAQs: createRemoteFeatureFlag({ key: 'adminDashboardOverviewFAQs', supportedValues: ['control', 'treatment'] }),
  adminDashboardOverviewHighlights: createRemoteFeatureFlag({ key: 'adminDashboardOverviewHighlights', supportedValues: ['control', 'variant1', 'variant2'] }),
  /*
   * Gift Wrap Remote Feature Flags
   */
  registryGiftWrapDefaultUSABillingAddress: createRemoteFeatureFlag('registrygiftwrapdefaultusabillingaddress'),
  registryGiftWrapEcardPrice: createRemoteFeatureFlag('registrygiftwrapecardprice'),
  registryGiftWrapExperimentEnabled: createRemoteFeatureFlag('registrygiftwrapexperimentenabled'),
  registryGiftWrapCashEnabled: createRemoteFeatureFlag('registrygiftwrapcashenabled'),
  registryGiftWrapAffiliateEnabled: createRemoteFeatureFlag('registrygiftwrapaffiliateenabled'),
  registryGiftWrapThemeDisplayCount: createRemoteFeatureFlag('registrygiftwrapthemedisplaycount'),
  registryGiftWrapThemeExpandIcon: createRemoteFeatureFlag({
    key: 'registrygiftwrapthemeexpandicon',
    supportedValues: ['plus', 'chevron'],
    defaultValue: 'plus',
  }),
  rsvpCongratulationsEcardUserIsInUS: createRemoteFeatureFlag('rsvpCongratulationsEcardUserIsInUS'),
  rsvpCongratulationsEcardExperimentEnabled: createRemoteFeatureFlag('rsvpCongratulationsEcardExperimentEnabled'),
  rsvpCongratulationsECardPrice: createRemoteFeatureFlag('rsvpCongratulationsECardPrice'),
  rsvpCongratulationsEventHandleExcludeList: createRemoteFeatureFlag('rsvpcongratulationseventhandleexcludelist'),
  rsvpVersion: createRemoteFeatureFlag({ key: 'rsvpVersion', supportedValues: ['basic', 'offer'] }),
  rsvpGuestFlowAccommodationsStep: createRemoteFeatureFlag({ key: 'rsvpguestflowaccommodationsstep', supportedValues: ['control', 'treatment', 'off'] }),
  rsvpGuestFlowAccommodationsStepWithAccoms: createRemoteFeatureFlag({ key: 'rsvpguestflowaccommodationsstepwithaccoms', supportedValues: ['control', 'treatment'] }),
  rsvpButtonCustomLabel: createRemoteFeatureFlag('rsvpbuttoncustomlabel'),
  /*
   * Print Remote Feature Flags
   */
  premiumEcardMessagingV3HistoryEnabled: createRemoteFeatureFlag({ key: 'premiumecardmessagingv3historyenabled', supportedValues: ['on', 'off'] }),
  messagingCenterPollingRates: createRemoteFeatureFlag({ key: 'messagingcenterpollingrates', supportedValues: ['on', 'off'] }),
  askGuestForHotelRecommendationsEnabled: createRemoteFeatureFlag({ key: 'askguestforhotelrecommendationsenabled', supportedValues: ['on', 'off'] }),
  printCouponCodeLaunch: createRemoteFeatureFlag({ key: 'printcouponcodelaunch', supportedValues: ['on'] }),
  printCreateWeddingRedirect: createRemoteFeatureFlag({ key: 'printcreateweddingredirect', supportedValues: ['control', 'treatment'] }),
  printDesignConciergeCheckoutEnabled: createRemoteFeatureFlag('printdesignconciergecheckoutenabled'),
  printSuperAdminDiscountEnabled: createRemoteFeatureFlag('printsuperadmindiscountenabled'),
  printGalleryThemeDisplayOrder: createRemoteFeatureFlag({ key: 'printgallerythemedisplayorder', supportedValues: ['on', 'off', 'order_a', 'order_b'] }),
  printDigitalInternationalShipping: createRemoteFeatureFlag({ key: 'printdigitalinternationalshipping', supportedValues: ['restricted', 'off'] }),
  printInternationalShipping: createRemoteFeatureFlag({ key: 'printinternationalshipping', supportedValues: ['restricted', 'off'] }),
  printImagineOptions: createRemoteFeatureFlag('printimagineoptions'),
  printImagineHoliday: createRemoteFeatureFlag('printimagineholiday'),
  printImagineStyles: createRemoteFeatureFlag('printimaginestyles'),
  printLocalCurrency: createRemoteFeatureFlag('printlocalcurrency'),
  printSaleCodeV2: createRemoteFeatureFlag({ key: 'printsalecodev2', supportedValues: ['group1', 'group2', 'group3'] }),
  printGalleryVideoAutoPlay: createRemoteFeatureFlag('printgalleryvideoautoplay'),
  printCouponCodeLaunchV2: createRemoteFeatureFlag('printcouponcodelaunchv2'),
  printSiteCrossSellModal: createRemoteFeatureFlag({ key: 'printsitecrosssellmodal', supportedValues: ['on', 'off'], defaultValue: 'off' }),
  printPremiumDigitalPricing: createRemoteFeatureFlag('printpremiumdigitalpricing'),
  printRegistryThankYouCrossSellExperiment: createRemoteFeatureFlag({ key: 'printregistrythankyoucrosssellexperiment', supportedValues: ['control', 'treatment'] }),
  printGalleryEnableSearch: createRemoteFeatureFlag('printgalleryenablesearch'),
  printSearch: createRemoteFeatureFlag('printsearch'),
  printSalesAllowedCountryList: createRemoteFeatureFlag({ key: 'printsalesallowedcountrylist', supportedValues: ['on', 'off'] }),
  printGalleryCardTileCarouselContent: createRemoteFeatureFlag('printgallerycardtilecarouselcontent'),
  printPdpEnableInteractivePrintPreview: createRemoteFeatureFlag('printpdpenableinteractiveprintpreview'),
  printPdpSuiteImage: createRemoteFeatureFlag({ key: 'printpdpsuiteimage', supportedValues: ['on', 'off'], defaultValue: 'off' }),
  printPaperFoilConfig: createRemoteFeatureFlag('printpaperfoilconfig'),
  printColorwaysDiagonalBands: createRemoteFeatureFlag({ key: 'printcolorwaysdiagonalbands', supportedValues: ['on', 'off'], defaultValue: 'off' }),
  printOrderTrackingUpdatedLogic: createRemoteFeatureFlag('printordertrackingupdatedlogic'),
  printCollectPhoneNumberOnIntlShippingAddressEnabled: createRemoteFeatureFlag({ key: 'printcollectphonenumberonintlshippingaddressenabled', supportedValues: ['on', 'off'] }),
  priceMatchGuaranteeExperiment: createRemoteFeatureFlag({ key: 'pricematchguaranteeexperiment', supportedValues: ['control', 'treatment'] }),
  bestPriceGuarantee: createRemoteFeatureFlag({ key: 'bestpriceguarantee', supportedValues: ['control', 'treatment'] }),
  remindMeLaterInGuestGuide: createRemoteFeatureFlag({ key: 'remindmelateringuestguide', supportedValues: ['on', 'off'] }),
  stationeryBusySeasonsShippingWarningsEnabled: createRemoteFeatureFlag('stationerybusyseasonsshippingwarningsenabled'),
  printAutofillPhotos: createRemoteFeatureFlag('printautofillphotos'),
  printPreviewWithPhotoCards: createRemoteFeatureFlag({ key: 'printpreviewwithphotocards', supportedValues: ['on', 'off'], defaultValue: 'off' }),
  printGalleryPageSize: createRemoteFeatureFlag('printgallerypagesize'),
  printCart: createRemoteFeatureFlag('printcart'),
  printEnableBasicDigitalV2: createRemoteFeatureFlag({ key: 'printenablebasicdigitalv2', supportedValues: ['on', 'off'], defaultValue: 'off' }),
  printCardEditorModes: createRemoteFeatureFlag({ key: 'printcardeditormodes', supportedValues: ['on', 'off'], defaultValue: 'off' }),
  /*
   * Website Designer Remote Feature Flags
   */
  websiteDesignerFullWebsitePreviewEnabled: createRemoteFeatureFlag({ key: 'websitedesignerfullwebsitepreviewenabled', supportedValues: ['on', 'off'] }),
  websiteHeaderMultilineTitleEnabled: createRemoteFeatureFlag({ key: 'websiteheadermultilinetitle', supportedValues: ['on', 'off'] }),
  /**
   * PRNT-5245: shows the "Only show video on welcome page" toggle in the Video Background
   * console. Gates discovery of the control only: an event that already opted in keeps it,
   * and guest rendering reads the persisted dataJSON field regardless of the flag.
   */
  videoBackgroundOnlyOnWelcomePageEnabled: createRemoteFeatureFlag({ key: 'videobackgroundonlyonwelcomepageenabled', supportedValues: ['on', 'off'] }),
  sunsetVideoPageEnabled: createRemoteFeatureFlag({ key: 'sunsetvideopageenabled', supportedValues: ['on', 'off'] }),
  /**
   * Sunsets the legacy Moments page for newly created events only. Read once in the create
   * funnels (wedding + baby registry) and persisted as the `sunsetMomentsPageEnabled` per-event
   * feature flag, so an existing event is never affected by the rollout percentage moving.
   * The key must match event_service's allowlist entry.
   */
  sunsetMomentsPageEnabled: createRemoteFeatureFlag({ key: 'sunsetmomentspageenabled', supportedValues: ['on', 'off'] }),
  websiteDesignerRecommendedDesignsFromPhoto: createRemoteFeatureFlag({ key: 'websitedesignerrecommendeddesignsfromphoto', supportedValues: ['on', 'off'] }),
  /**
   * PRNT-4778: shows the Maps section in the Colors panel, where couples pick
   * which skin their venue maps render with. Stays off until
   * `eventDesign.mapStyle` lands on the backend -- until then the choice is
   * local-only and would not survive a reload.
   */
  websiteDesignerMapStyleEnabled: createRemoteFeatureFlag({ key: 'websitedesignermapstyleenabled', supportedValues: ['on', 'off'] }),
  websiteTemplatesEnableThumbnailAutoplay: createRemoteFeatureFlag({ key: 'websitetemplatesenablethumbnailautoplay', supportedValues: ['on', 'off'] }),
  websiteTemplatesEnableDefaultPhotoFallback: createRemoteFeatureFlag({ key: 'websitetemplatesenabledefaultphotofallback', supportedValues: ['on', 'off'] }),
  websiteFullySsrGuestSite: createRemoteFeatureFlag('websitefullyssrguestsite'),
  websiteTemplatesLivePreviewEnabled: createRemoteFeatureFlag({ key: 'websitetemplateslivepreviewenabled', supportedValues: ['on', 'off'] }),
  // Entry-point experiment for AI website templates in the gallery.
  // control    = existing TemplateGalleryPreviewPopover intro
  // treatment1 = StartWithPhotoBanner (full-width inline gallery banner)
  // treatment2 = StartWithPhotoDialog (intro modal)
  aiWebsiteTemplatesEntryExperiment: createRemoteFeatureFlag({
    // Amplitude flag key must be lowercase — the factory does not lowercase `key`, and a
    // camelCase key won't match the remote flag (silently falls back to the default).
    key: 'aiwebsitetemplatesentryexperiment',
    supportedValues: ['control', 'treatment1', 'treatment2'],
    defaultValue: 'control',
  }),
  websiteTemplateValuePropsData: createRemoteFeatureFlag({ key: 'websitetemplatevaluepropsdata', supportedValues: ['on'] }),
  // Draggable divider between the unified editor's left panel and the website preview.
  unifiedEditorResizablePanelEnabled: createRemoteFeatureFlag({ key: 'unifiededitorresizablepanelenabled', supportedValues: ['on', 'off'] }),
  /**
   * Drives charm server -- fetches amplitude FF variants to be hydrated during SSR.
   */
  websiteCharmFullySsrGuestSite: createRemoteFeatureFlag('websitecharmfullyssrguestsite'),
  /**
   * PLAN-17: consolidate the guest-site SSR queries. When on, a single
   * GuestSiteEventData query is fired in prefetchData to pre-warm the Apollo cache
   * so the legacy eventByName queries resolve cache-first (one eventByName
   * resolution per SSR instead of four).
   */
  guestSiteConsolidatedSsrQuery: createRemoteFeatureFlag('guestsiteconsolidatedssrquery'),
  websitePhotoMonetizationEnabled: createRemoteFeatureFlag({ key: 'websitephotomonetizationenabled', supportedValues: ['on', 'off'] }),

  /*
   * Registry Admin Remote Feature Flags
   */
  messagingEnableHotelBlockReminderNotification: createRemoteFeatureFlag('messagingenablehotelblockremindernotification'),
  messagingEnableHotelBlockReminderSMS: createRemoteFeatureFlag('messagingenablehotelblockremindersms'),
  registryCashFundCurrency18nEnabled: createRemoteFeatureFlag('registryCashFundCurrency18nEnabled'),
  leanInternationalRegistryEnabled: createRemoteFeatureFlag({ key: 'leaninternationalregistryenabled', supportedValues: ['on', 'off'] }),
  registryDisableSyncRegistry: createRemoteFeatureFlag({ key: 'registryDisableSyncRegistry', supportedValues: ['control', 'treatment'] }),
  registrySyncIsDisabledDate: createRemoteFeatureFlag({ key: 'registrySyncIsDisabledDate' }),
  registryKycLaterEnabled: createRemoteFeatureFlag('registryKycLaterEnabled'),
  registryAddCashFundV2Enabled: createRemoteFeatureFlag({ key: 'registryaddcashfundv2enabled', supportedValues: ['on', 'off'] }),
  /** Kill switch for host-first ordering only. When 'on', Add Cash Fund V2 skips the host step at start; host setup stays reachable from the credit-card toggle. */
  registryAddCashFundSkipHostStep: createRemoteFeatureFlag({ key: 'registryaddcashfundskiphoststep', supportedValues: ['on', 'off'] }),
  registryShopOutOfStockBadgeEnabled: createRemoteFeatureFlag({ key: 'registryshopoutofstockbadgeenabled', supportedValues: ['on', 'off'] }),
  registryShopRegionDialogEnabled: createRemoteFeatureFlag({ key: 'registryshopregiondialogenabled', supportedValues: ['on', 'off'] }),
  registryPdpReviewsRefreshEnabled: createRemoteFeatureFlag({ key: 'registrypdpreviewsrefreshenabled', supportedValues: ['on', 'off'] }),
  registryManageOutOfStockBadgeEnabled: createRemoteFeatureFlag({ key: 'registrymanageoutofstockbadgeenabled', supportedValues: ['on', 'off'] }),
  registryDashboardTitlesExperiment: createRemoteFeatureFlag({ key: 'registryDashboardTitlesExperiment', supportedValues: ['control', 'treatment'] }),
  registryOverviewVirtualConsultation: createRemoteFeatureFlag({ key: 'registryOverview-VirtualConsultation', supportedValues: ['control', 'treatment'] }),
  //old universal recommendation flag - buggy flag - we keep it here to rise an issue to amplitude
  syncAndTransferRegistryProductRecommendation: createRemoteFeatureFlag({
    key: 'syncAndTransferRegistryProductRecommendation',
    supportedValues: ['control', 'treatmentskipextrastepsintransfersync', 'treatmentfullrecommendationflow'],
  }),
  /*
   * Travel Remote Feature Flags
   */
  hotelBlockEnabled: createRemoteFeatureFlag({ key: 'hotelBlockEnabled', supportedValues: ['on', 'off'] }),
  hotelBlockOptionalPriceEnabled: createRemoteFeatureFlag({ key: 'hotelBlockOptionalPriceEnabled', supportedValues: ['on', 'off'] }),
  shortlistReleased: createRemoteFeatureFlag('shortlistreleased'),
  hotelBlockContactMethodMeeting: createRemoteFeatureFlag({ key: 'hotelBlockContactMethodMeeting', supportedValues: ['off', 'on'] }),
  hotelBlockContactMethodSms: createRemoteFeatureFlag({ key: 'hotelBlockContactMethodSms', supportedValues: ['off', 'on'] }),
  hotelBlockContactMethodEmail: createRemoteFeatureFlag({ key: 'hotelBlockContactMethodEmail', supportedValues: ['off', 'on'] }),
  newtimepickerEnabled: createRemoteFeatureFlag({ key: 'newtimepicker', supportedValues: ['on', 'off'] }),
  perkIntercomWorkflowTest: createRemoteFeatureFlag({ key: 'perkIntercomWorkflowTest', supportedValues: ['on', 'off'] }),
  roomBlockManagerDialogPerkPrintPromoCode: createRemoteFeatureFlag({ key: 'roomblockmanagerdialogperkprintpromocode', supportedValues: ['on', 'off'] }),
  roomBlockManagerDialogRegistryPromoCode: createRemoteFeatureFlag({ key: 'roomblockmanagerdialogregistrypromocode', supportedValues: ['on', 'off'] }),
  messagingPostRsvpHotelSearchUrl: createRemoteFeatureFlag({ key: 'messagingpostrsvphotelsearchurl', supportedValues: ['off', 'on'] }),
  postRSVPEnableNearbyHotelsCard: createRemoteFeatureFlag({ key: 'postrsvpenablenearbyhotelscard', supportedValues: ['control', 'treatment'] }),
  // Gates the field-backed "Guest Hotel Booking Reminder" toggle (travelSettings.hotelBookingReminderEnabled) in Where to Stay settings
  // Gates the "Pre and post first booking emails" toggle (travelSettings.preAndPostFirstBookingEmailsEnabled) in the Service Center travel email settings.
  // Amplitude flag key must be lowercase — the factory does not lowercase `key`, and a camelCase key won't match the remote flag (silently falls back to the default).
  preAndPostFirstBookingEmailsEnabled: createRemoteFeatureFlag({ key: 'preandpostfirstbookingemailsenabled', supportedValues: ['on', 'off'] }),
  venueAddressLocationEnabled: createRemoteFeatureFlag({ key: 'venueAddressLocationEnabled', supportedValues: ['on', 'off'] }),
  hotelRedirectInterceptorEnabled: createRemoteFeatureFlag({ key: 'hotelRedirectInterceptorEnabled', supportedValues: ['on', 'off'] }),
  travelAccommodationConnectionEnabled: createRemoteFeatureFlag({ key: 'travelAccommodationConnectionEnabled', supportedValues: ['on', 'off'] }),
  travelAccommodationsConsoleV2: createRemoteFeatureFlag({ key: 'travelaccommodationsconsolev2', supportedValues: ['control', 'treatment'] }),
  // Gates the full-canvas Guest Stays Dashboard on the Accommodations Bookings tab.
  guestStaysDashboard: createRemoteFeatureFlag({ key: 'gueststaysdashboard', supportedValues: ['on', 'off'], defaultValue: 'off' }),
  travelCarRentalConsole: createRemoteFeatureFlag({ key: 'travelCarRentalConsole', supportedValues: ['control', 'treatment'] }),
  /** Experiment flag and kill switch for car rental pins on the accommodations map. */
  accomMapCarPins: createRemoteFeatureFlag({ key: 'accommapcarpins', supportedValues: ['control', 'treatment'] }),
  /** Experiment: show Hotels|Cars toggle on guest hotel/car search (not travelCarRentalConsole). */
  travelHotelCarProductToggle: createRemoteFeatureFlag({ key: 'travelhotelcarproducttoggle', supportedValues: ['control', 'treatment'] }),
  localeBasedHotelCurrency: createRemoteFeatureFlag({ key: 'localeBasedHotelCurrency', supportedValues: ['on', 'off'] }),
  // Enables page currency setting in accommodations settings
  enableAccommodationsPriceComparisonV2: createRemoteFeatureFlag({ key: 'enableAccommodationsPriceComparisonV2', supportedValues: ['on', 'off'] }),
  accommodationsPriceComparisonExperiment: createRemoteFeatureFlag({ key: 'accommodationsPriceComparisonExperiment', supportedValues: ['link', 'price', 'no-comparison'] }),
  minimumPercentageOffToDisplay: createRemoteFeatureFlag({ key: 'minimumPercentageOffToDisplay', supportedValues: ['on', 'off'] }),
  accommodationPlaceUserNote: createRemoteFeatureFlag({ key: 'accommodationplaceusernote', supportedValues: ['on', 'off'] }),
  accommodationsDiscountTooltipEnabled: createRemoteFeatureFlag({ key: 'accommodationsDiscountTooltipEnabled', supportedValues: ['control', 'treatment'] }),
  /**
   * A/B test (event_service TRAV-4400): whether the wedding-code accommodations note/banner also
   * includes a sentence explaining that booking through the site helps the couple track guest
   * lodging. Bucketed by JoyEvent (event firebaseId) to match event_service's own evaluation of
   * this same flag, so the backend note (baked in once at event creation) and this banner never
   * disagree for a given event. See useWeddingCodeBannerEligibility.ts / WeddingCodeBannerContainer.tsx.
   */
  accommodationsNoteCopies: createRemoteFeatureFlag({
    key: 'accommodationsnotecopies',
    supportedValues: ['control', 'treatment'],
    defaultValue: 'control',
  }),
  accommodationsOnboardingDialog: createRemoteFeatureFlag({ key: 'accommodationsonboardingdialog', supportedValues: ['control', 'treatment'] }),
  accommodationsVenueMatchSuggestion: createRemoteFeatureFlag({ key: 'accommodations-venue-match-suggestion', supportedValues: ['control', 'treatment'] }),

  accomodationsNewMobilePDPEnabled: createRemoteFeatureFlag('accommodationsnewmobilepdp'),
  accommodationsPlaceholdersCountOverride: createRemoteFeatureFlag('accommodationsplaceholderscountoverride'),
  hotelpdp3: createBooleanFeatureFlag('hotelpdp3', false),
  /** Gates the extend-stay flow: the `/travel/modifyreservation/:reservationId` page and its confirmation-page CTA. */
  extendStayEnabled: createBooleanFeatureFlag('extendStayEnabled', true),
  accommodationsCustomPageSlugKeywords: createRemoteFeatureFlag('accommodationsCustomPageSlugKeywords'),
  travelStripeExpressPayments: createRemoteFeatureFlag({ key: 'travelStripeExpressPayments', supportedValues: ['control', 'treatment'] }),
  travelStripeExpressPaymentsPDP: createRemoteFeatureFlag({ key: 'travelStripeExpressPaymentsPDP', supportedValues: ['control', 'treatment'] }),
  accommodationsTravelDistanceExperiment: createRemoteFeatureFlag({ key: 'accommodationsTravelDistanceExperiment', supportedValues: ['control', 'treatment'] }),
  // Kill-switch for Google-routed travel metrics on the hotel PDP.
  hotelPdpGoogleTravelMetricsEnabled: createRemoteFeatureFlag({
    key: 'hotelpdpgoogletravelmetricsenabled',
    supportedValues: ['on', 'off'],
  }),
  // feature flag with payload of all hotel coupons, used for shared look-up between FE and travel_reservation_service
  travelHotelCoupons: createRemoteFeatureFlag({ key: 'travelHotelCoupons', supportedValues: ['on', 'off'] }),
  travelHotelPDPCreatesReservation: createRemoteFeatureFlag({ key: 'travelHotelPDPCreatesReservation', supportedValues: ['on', 'off'] }),
  /** Hides non-refundable rates that are outpriced by a refundable rate for the same board basis. */
  hideExpensiveNonRefundableRates: createRemoteFeatureFlag({ key: 'hideExpensiveNonRefundableRates', supportedValues: ['control', 'treatment'] }),
  /**
   * Renders the all-in whole-stay total — taxes plus the fees the guest pays at the property —
   * instead of the collected total, on search cards and PDP rate cards (TRAV-4298).
   * Read it through `useIsAllInTotalEnabled` rather than directly, so display and list ordering
   * never disagree about which arm they are in. Checkout is deliberately not part of this
   * experiment: it already sums the onsite charges into its Total row.
   */
  travelAllInTotalExperiment: createRemoteFeatureFlag({ key: 'travelAllInTotalExperiment', supportedValues: ['control', 'treatment'] }),
  /** For surfacing AI generated properties on auto-populated accommodations (whyThisHotelIsAGreatPick and proposedNoteFromHostToGuest) */
  travelAutoPopulatedAiNotesSurfaced: createRemoteFeatureFlag({ key: 'travelAutoPopulatedAiNotesSurfaced', supportedValues: ['on', 'off'] }),
  venueLocationSyncToggle: createRemoteFeatureFlag({ key: 'venuelocationsynctoggle', supportedValues: ['on', 'off'] }),
  /** Enables offer token refresh on checkout page when offer is expired/invalid */
  travelCheckoutRefreshOfferToken: createRemoteFeatureFlag({ key: 'travelCheckoutRefreshOfferToken', supportedValues: ['control', 'treatment'] }),
  travelCheckoutRecoverOfferOnSubmit: createRemoteFeatureFlag({ key: 'travelCheckoutRecoverOfferOnSubmit', supportedValues: ['control', 'treatment'] }),
  /** A/B experiment: Joy discount coupon field on travel checkout (TRAV-3420) */
  travelCheckoutJoyCoupon: createRemoteFeatureFlag({ key: 'travelCheckoutJoyCoupon', supportedValues: ['control', 'treatment'] }),
  /**
   * A/B test: the dates-specific "Change your dates" link on the checkout offer summary (TRAV-4169).
   * Control keeps only the older "Change your selection" link, so neither arm strands a guest at
   * checkout. Defaults to `treatment` on purpose: the link is already live, and a flag-fetch failure
   * should not silently remove it. A defaulted guest fires no exposure event, so the default cannot
   * bias the comparison. The link stays hidden while the flag is still fetching, so a control guest
   * can never tap it before assignment resolves.
   *
   * Key is lowercase because the Amplitude flag key must be; see .agents/skills/creating-joy-feature-flags.
   */
  travelCheckoutChangeDatesExperiment: createRemoteFeatureFlag({
    key: 'travelcheckoutchangedatesexperiment',
    supportedValues: ['control', 'treatment'],
    defaultValue: 'treatment',
  }),
  /** Experiment flag for the cash-fund hotel-search variant (TRAV-3348) */
  hotelsSearchCashFundExperiment: createRemoteFeatureFlag({ key: 'hotelsSearchCashFundExperiment', supportedValues: ['control', 'treatment'] }),
  /** A/B test: cash-fund checkout UI (fund vs. card CTA) for logged-in couples with enough fund. See TRAV-3349 */
  travelCheckoutCashFundExperiment: createRemoteFeatureFlag({ key: 'travelCheckoutCashFundExperiment', supportedValues: ['control', 'treatment'] }),
  /** Enables AI recommendations note to show on tour step else show tags. See TRAV-1859 */
  aiRecommendationsNoteEnabled: createRemoteFeatureFlag({ key: 'aiRecommendationsNoteEnabled', supportedValues: ['on', 'off'] }),
  /** A/B test: Hide visibility toggle on accommodations page */
  /** Experiment A: Promotes hotel deals with countdown subtitle in guest guide */
  guestGuideHotelDealsPromotionExperiment: createRemoteFeatureFlag({ key: 'guestGuideHotelDealsPromotionExperiment', supportedValues: ['control', 'treatment'] }),
  /** Experiment B: Shows prominent booking CTA card at top of guest guide */
  guestGuideBookingCtaExperiment: createRemoteFeatureFlag({ key: 'guestGuideBookingCtaExperiment', supportedValues: ['control', 'treatment'] }),
  /** Gates the "Book a Car" CTA in the guest guide; ships dark until ramped. */
  guestGuideCarRentalAction: createRemoteFeatureFlag({ key: 'guestguidecarrentalaction', supportedValues: ['on', 'off'] }),
  /** Compact 2-column card layout for hotel PDP on mobile — treatment shows compact cards with drawer detail view */
  hotelPDPCompactCards: createRemoteFeatureFlag({ key: 'hotelPDPCompactCards', supportedValues: ['control', 'treatment'] }),
  /** Promotes alternate-provider offers into the main grid so at least `payload.minOfferCount` offers are visible before "Show More". Rollout concluded (100% treatment); kept for its remotely-tunable payload */
  alternateProviderMinimumOffers: createRemoteFeatureFlag({ key: 'alternateproviderminimumoffers', supportedValues: ['control', 'treatment'] }),
  /** Prioritizes offers with images when promoting alternate-provider offers into the main grid */
  alternateProviderImagePrioritySort: createRemoteFeatureFlag({ key: 'alternateproviderimageprioritysort', supportedValues: ['control', 'treatment'] }),
  /** TRAV-3561 — Renders the Share Your Stay promo card on the reservation success page */
  travelShareBookingPromo: createRemoteFeatureFlag({ key: 'travelShareBookingPromo', supportedValues: ['control', 'treatment'] }),
  /**
   * Experiment: how the Share Your Stay treatment screen presents the referral offer to the booker.
   * Layered on the backend's `travel-share-your-stay-referral` flag, which alone decides whether a code
   * is minted and what it pays — this only picks the copy. `v1` is the original give-and-get screen,
   * so an unresolved flag renders exactly what shipped before this experiment existed.
   */
  travelShareYourStayPresentation: createRemoteFeatureFlag({ key: 'travelshareyourstaypresentation', supportedValues: ['v1', 'fineprint', 'silent'], defaultValue: 'v1' }),
  /** Experiment: static car-rental upsell alongside a successful hotel booking confirmation */
  travelHotelConfirmationCarUpsell: createRemoteFeatureFlag({ key: 'travelhotelconfirmationcarupsell', supportedValues: ['control', 'treatment'], defaultValue: 'control' }),
  /*
   * Contact Collection Feature Flags
   */
  contactCollectionSmsAgreementVariant: createRemoteFeatureFlag({ key: 'contactCollectionSmsAgreementVariant', supportedValues: ['variant1', 'variant2'] }),
  enableContactCollectionMessage: createRemoteFeatureFlag({ key: 'enablecontactcollectionmessage', supportedValues: ['on', 'off'] }),
  contactCollectionDisablePhoneNumberValidationFor: createRemoteFeatureFlag('contactcollectiondisablephonenumbervalidationfor'),
  /** Restructures Contact Collector admin into a Send / Activity / Settings tabnav and unifies the experience across `/contact` and `/collect-contacts` */
  /** Per-collector REQUIRED/OPTIONAL/OFF settings for email/phone/address. Gates admin UI and guest field-rule reading. */
  contactCollectorFieldSettingsEnabled: createRemoteFeatureFlag({ key: 'contactCollectorFieldSettingsEnabled', supportedValues: ['on', 'off'] }),
  /** Optional Title (prefix) / Suffix inputs in the Contact Collector guest form, admin iframe and print recipients dialog. Off hides the inputs; stored values still round-trip untouched. */
  contactCollectorNameAffixesEnabled: createRemoteFeatureFlag({ key: 'contactCollectorNameAffixesEnabled', supportedValues: ['on', 'off'] }),
  /**
   * Default-country selector in the CSV import dialog for phone numbers without a Country
   * column (LGL-46). Off = selector hidden and no `countryCode` sent, byte-for-byte the
   * pre-LGL-46 import. No defaultValue on purpose: the FE ships dark until Amplitude ramps it.
   */
  csvImportDefaultCountryEnabled: createRemoteFeatureFlag({ key: 'csvImportDefaultCountryEnabled', supportedValues: ['on', 'off'] }),
  shopSubCatHighlightsExperiment: createRemoteFeatureFlag({ key: 'shopSubCatHighlightsExperiment', supportedValues: ['control', 'treatment'] }),

  weddingShopFeatureEnabled: createRemoteFeatureFlag({ key: 'weddingshopfeatureenabled', supportedValues: ['on', 'off', 'variant2'] }),
  /**
   * Admin Dashboard
   */
  photoAlbumMultiPhotoUploadEnabledV2: createRemoteFeatureFlag({ key: 'photoalbummultiphotouploadv2', supportedValues: ['on', 'off'] }),
  // The upload widget itself: on = uploads go through the in-house widget + file upload service,
  // off = legacy Filestack. Gates the widget, its client, and every migrated consumer.
  joyUploadWidgetEnabled: createRemoteFeatureFlag({ key: 'joyuploadwidgetenabled', supportedValues: ['on', 'off'] }),
  albumSlideShowExperiment: createRemoteFeatureFlag({ key: 'albumSlideShowExperiment', supportedValues: ['control', 'treatment'] }),
  allCollectionPhotosEnabled: createRemoteFeatureFlag({ key: 'allcollectionphotosenabled', supportedValues: ['on', 'off'] }),
  photoUploadFromCollectionEnabled: createRemoteFeatureFlag({ key: 'photouploadfromcollection', supportedValues: ['on', 'off'] }),
  websiteThingsToDoAnnouncement: createRemoteFeatureFlag({ key: 'websiteThingsToDoAnnouncement', supportedValues: ['on', 'off'] }),
  eventPhotoV2UrlMigration: createRemoteFeatureFlag({ key: 'eventphotov2urlmigration', supportedValues: ['on', 'off'] }),
  /** Gates the "Guests Participation" entry (album likes) in PhotosV2 album settings. */
  websiteGuestParticipationEnabled: createRemoteFeatureFlag({ key: 'websiteguestparticipationenabled', supportedValues: ['on', 'off'] }),
  /** Guest album lightbox V2 (`AlbumLightbox`); off falls back to the YARL-based `InteractiveLightbox`. */
  websiteGuestLightboxV2Enabled: createRemoteFeatureFlag({ key: 'websiteguestlightboxv2enabled', supportedValues: ['on', 'off'] }),
  /**
   * Guest photo comments: the admin per-album "Comments" toggle and the comment pane in
   * `AlbumLightbox`. Comments additionally require `websiteGuestLightboxV2Enabled` — consumers
   * must gate on the conjunction of both flags (comments-on + lightbox-off means no comments).
   */
  websiteGuestCommentsEnabled: createRemoteFeatureFlag({ key: 'websiteguestcommentsenabled', supportedValues: ['on', 'off'] }),
  websitePhotoAssignToPageEnabled: createRemoteFeatureFlag('websitephotosassigntopageenabled'),
  websiteReplaceDefaultPhotosEnabled: createRemoteFeatureFlag('websitereplacedefaultphotosenabled'),
  websitePhotosEngagementAlbumEnable: createRemoteFeatureFlag('websitephotosengagementalbumenable'),
  /**
   * Gates the photo upload-window / storage-expiration UX everywhere: admin pills, banners and
   * dialogs (`usePhotoAccessState`) and the guest album/gallery gating (`useGuestPhotoAccess`).
   * All states derive from the backend photo-access fields.
   */
  websitePhotosExpirationEnabled: createRemoteFeatureFlag({ key: 'websitephotosexpirationenabled', supportedValues: ['on', 'off'] }),
  /** Gates manual drag-and-drop photo reordering + the "Manual order" sort option in PhotosV2 albums. */
  websitePhotosManualReorderEnabled: createRemoteFeatureFlag('websitephotosmanualreorderenabled'),
  /**
   * Gates the "Quick actions" sidebar beside the PhotosV2 album grid — Album Visibility / Guest
   * Uploads / Likes / Comments / Share / Download All move out of the inline settings row into it,
   * and Edit / Sort / Reorder move to the header and heading row. Evaluated at every width so the
   * experiment buckets phones too, but the sidebar renders only >= 768px; below that "Manage Album"
   * still owns these controls.
   * No defaultValue on purpose: the FE ships dark until Amplitude ramps it.
   */
  websiteAlbumQuickActionsEnabled: createRemoteFeatureFlag({ key: 'websitealbumquickactionsenabled', supportedValues: ['on', 'off'] }),
  printStudioOnDashboard: createRemoteFeatureFlag({ key: 'printstudioondashboard', supportedValues: ['on', 'off'] }),

  /**
   * Guest site
   */
  websiteVideoBackgroundEnabled: createRemoteFeatureFlag({ key: 'websiteVideoBackgroundEnabled', supportedValues: ['on', 'off'] }),
  websiteMastheadEnabled: createRemoteFeatureFlag({ key: 'websitemastheadenabled', supportedValues: ['on', 'off'] }),
  pageWidthAnimatedLayoutsEnabled: createRemoteFeatureFlag({ key: 'pagewidthanimatedlayoutsenabled', supportedValues: ['on', 'off'] }),

  websiteInterceptExternalHotelLinksV2: createRemoteFeatureFlag({ key: 'websiteinterceptexternalhotellinksv2', supportedValues: ['on', 'off'] }),
  websiteInterceptExternalHotelLinksAdmin: createRemoteFeatureFlag({ key: 'websiteinterceptexternalhotellinksadmin', supportedValues: ['on', 'off'] }),
  guestguideexperiment: createRemoteFeatureFlag({
    key: 'guestguideexperiment',
    supportedValues: ['control', 'treatment'],
    consentValueForTrue: 'treatment',
  }),
  showGuestGuide: createFeatureFlagConfig('showGuestGuide', true),
  // Price alerts experiment. Also a UserConsentKey (same name), so hosts/CX can override the
  // Amplitude assignment per event: consent `true` → treatment, `false` → control, unset → Amplitude.
  accommodationsPriceAlerts: createRemoteFeatureFlag({
    key: 'accommodationsPriceAlerts',
    supportedValues: ['control', 'treatment'],
    consentValueForTrue: 'treatment',
  }),
  accommodationsPageCountdown: createRemoteFeatureFlag({ key: 'accommodationsPageCountdown', supportedValues: ['control', 'treatment'] }),
  guestSkipPagePhotoRendition: createRemoteFeatureFlag({ key: 'guestskippagephotorendition', supportedValues: ['on', 'off'] }),
  guestMobileFooterNavEnabled: createRemoteFeatureFlag({ key: 'guestmobilefooternav', supportedValues: ['on', 'off'] }),
  websiteSelfHostedGoogleFontsEnabled: createRemoteFeatureFlag({ key: 'websiteselfhostedgooglefontsenabled', supportedValues: ['on', 'off'] }),
  websiteInitialHeaderAnimationDisabled: createRemoteFeatureFlag({ key: 'websiteinitialheaderanimationdisabled', supportedValues: ['on', 'off'] }),

  /**
   * Webiste Design
   */
  joyWebAppBoundaryEnabled: createRemoteFeatureFlag({ key: 'joywebappboundaryenabled', supportedValues: ['on', 'off'] }),
  /** "Get started" onboarding tour for the website editor (coachmarks + checklist drawer). Desktop only. */
  websiteGetStartedOnboardingEnabled: createRemoteFeatureFlag({ key: 'websitegetstartedonboardingenabled', supportedValues: ['on', 'off'] }),
  /**
   * Pre-publish "Go Live Checks" readiness wizard in the website editor. On, the editor's Publish
   * control opens the wizard instead of `UnpublishedWebsiteWarning` and the old publish flow does
   * not run; off is byte-identical to today's behaviour. Doubles as the kill switch during rollout.
   */
  websiteGoLiveChecksEnabled: createRemoteFeatureFlag({ key: 'websitegolivechecksenabled', supportedValues: ['on', 'off'], defaultValue: 'off' }),
  websiteTemplateOrdering: createRemoteFeatureFlag({ key: 'websitetemplateordering', supportedValues: ['on', 'off', 'treatment'] }),
  hotelFirstPartySearchEnabled: createRemoteFeatureFlag({ key: 'hotelfirstpartysearchenabled', supportedValues: ['control', 'treatment'] }),
  adminDashboardHoneymoonEnabled: createRemoteFeatureFlag({ key: 'adminDashboardHoneymoonEnabled', supportedValues: ['on', 'off'] }),
  // Parent gate for the dashboard's Travel dropdown; off restores today's single-destination Guests Stays tile.
  adminDashboardTravelDropdown: createRemoteFeatureFlag({ key: 'admindashboardtraveldropdown', supportedValues: ['control', 'treatment'], defaultValue: 'control' }),
  // Honeymoon Painted Door experiment — master kill switch; payload carries { maxEventAgeHours }.
  honeymoonPaintedDoorEnabled: createRemoteFeatureFlag({ key: 'honeymoonPaintedDoorEnabled', supportedValues: ['on', 'off'] }),
  // Honeymoon Painted Door experiment — per-version experiment (US-targeted). One per version (V1, V2, …).
  honeymoonPaintedDoorV1: createRemoteFeatureFlag({ key: 'honeymoonPaintedDoorV1', supportedValues: ['on', 'off'] }),
  honeymoonPaintedDoorV2: createRemoteFeatureFlag({ key: 'honeymoonPaintedDoorV2', supportedValues: ['on', 'off'] }),
  // Honeymoon Painted Door experiment — shared "seen" consent key (also a UserConsentKey); required so
  // useIsFeatureEnabled({ consentKey: 'honeymoonPaintedDoorSeen' }) resolves to a valid ConsentFeatureFlagKey.
  honeymoonPaintedDoorSeen: createRemoteFeatureFlag({ key: 'honeymoonPaintedDoorSeen', supportedValues: ['on', 'off'] }),
  // Website V2 dashboard introduction — per-event "seen" consent key (also a UserConsentKey); registered
  // only so useIsFeatureEnabled({ consentKey: 'websiteV2IntroductionSeen' }) resolves, not remotely evaluated.
  websiteV2IntroductionSeen: createRemoteFeatureFlag({ key: 'websiteV2IntroductionSeen', supportedValues: ['on', 'off'] }),
  accommodationsGuestHotelTileExperiment: createRemoteFeatureFlag({ key: 'accommodationsGuestHotelTileExperiment', supportedValues: ['control', 'treatment'] }),
  /** Experiment flag: sold-out hotels open their Joy PDP ("View") with an "Explore Hotels Nearby" secondary CTA */
  accommodationsSoldOutPdpExperiment: createRemoteFeatureFlag({ key: 'accommodationsSoldOutPdpExperiment', supportedValues: ['control', 'treatment'] }),
  /** Experiment gating the "Our Pick" pill on host-favorited accommodations, bucketed by JoyEvent (not per guest) */
  accommodationsFavoriteTagEventExperiment: createRemoteFeatureFlag({
    key: 'accommodationsfavoritetageventexperiment',
    supportedValues: ['control', 'treatment'],
  }),
  /** Experiment gating the "Guest Favorite" pill on guest-favorited accommodations */
  guestFavoriteHotelTag: createRemoteFeatureFlag({
    key: 'guestfavoritehoteltag',
    supportedValues: ['control', 'treatment'],
  }),
  /**
   * ABC experiment on how a wedding room block is presented on the guest accommodations page.
   *
   *   - `control`     — today's standard room-block tile, in its usual list position.
   *   - `treatment_a` — the richer room-block card (photo, block rate, couple's note, its own
   *                     "Book at Group Rate" CTA), hoisted to the top of the hotel list.
   *   - `treatment_b` — the same content promoted out of the list entirely, into the full-width
   *                     slot above the map+grid.
   *
   * **Bucketed by JoyEvent (event firebaseId), not per guest.** A room block is a property of the
   * wedding, not of the viewer: guests of one event compare this page with each other, so splitting
   * them across arms would both confuse them and correlate the samples. Group identity already rides
   * on every exposure (`amplitudeExposureTracking.ts` puts `JoyEvent` top-level precisely so
   * anonymous guests — the majority of accommodations traffic — stay in group analysis). The choice
   * itself lives in Amplitude's flag config, not here; this comment is the contract.
   *
   * Read once in `Accommodations.tsx`, skipped until the guest is actually eligible (default layout
   * resolved AND the event has a room block) — exposure fires on read, so an ungated read would
   * enroll the whole accommodations audience, most of whom can see no difference in any arm.
   *
   * `defaultValue: 'control'` so a slow or unavailable flag service renders today's page rather than
   * a half-applied treatment.
   */
  accommodationsRoomBlockLayoutExperiment: createRemoteFeatureFlag({
    key: 'accommodationsroomblocklayoutexperiment',
    supportedValues: ['control', 'treatment_a', 'treatment_b'],
    defaultValue: 'control',
  }),
  /** Experiment flag to test different versions of the accommodation visibility confirmation modal */
  accommodationVisibilityConfirmationModalExperiment: createRemoteFeatureFlag({
    key: 'accommodationvisibilityconfirmationmodalexperiment',
    supportedValues: ['0', '1', '2', '3'],
    defaultValue: '0',
  }),
  /** Experiment: show layout selector in the accommodations turn-off dialog instead of text-based dissuasion */
  accommodationTurnOffLayoutSelector: createRemoteFeatureFlag({
    key: 'accommodationturnofflayoutselector',
    supportedValues: ['control', 'treatment'],
  }),
  /** A/B test: Hotel list action bar — consolidates Sparkle/Manage/Suggest into a "More" dropdown next to Add */
  hotelListActionBarExperiment: createRemoteFeatureFlag({ key: 'hotelListActionBarExperiment', supportedValues: ['control', 'treatment'] }),
  bookingCountExperiment: createRemoteFeatureFlag({ key: 'bookingCountExperiment', supportedValues: ['control', 'treatment'] }),
  /** Controls which currency codes are available in the travel currency selector via payload */
  travelCurrencies: createRemoteFeatureFlag({ key: 'travelCurrencies', supportedValues: ['control', 'treatment'] }),
  /**
   * Settings for the honeymoon hotel-search flow; the payload carries them all — the default search
   * location, the promo's savings figures, and the dialog's balance threshold. Every field needs a
   * code-side default, so a missing or malformed payload degrades to today's behaviour rather than
   * blanking a page.
   */
  travelHoneymoonConfig: createRemoteFeatureFlag({ key: 'travelHoneymoonConfig', supportedValues: ['on', 'off'] }),
  /**
   * Create page - Native specs
   */
  createPageNativeSpecs: createRemoteFeatureFlag({ key: 'createPageNativeSpecs', supportedValues: ['control', 'treatment'] }),
  /**
   * Dashboard Travel Survey
   */
  dashboardTravelSurvey: createRemoteFeatureFlag({ key: 'dashboardTravelSurvey', supportedValues: ['on', 'off'] }),
  /**
   * Honeymoon lead gen Survey
   */
  honeymoonLeadGenSurvey: createRemoteFeatureFlag({ key: 'honeymoonLeadGenSurvey', supportedValues: ['on', 'off'] }),
  /**
   * Day-Of Coordinator Survey
   */
  dayOfLeadGenSurvey: createRemoteFeatureFlag({ key: 'dayOfLeadGenSurvey', supportedValues: ['on', 'off'] }),
  /**
   * Cancellation Reason Survey
   */
  cancellationReasonSurvey: createRemoteFeatureFlag({ key: 'cancelationreasonsurvey', supportedValues: ['on', 'off'] }),
  /**
   * Gates the hotel cancellation-reason survey's survey_data_service integration (both showing
   * the survey and submitting its response) independently of the legacy `cancellationReasonSurvey`
   * flag, so the whole feature can be staged per environment as `hotelCancellationSurveyId` gets
   * populated. See CancellationDialog.tsx.
   */
  hotelCancellationSurveyDataService: createRemoteFeatureFlag({ key: 'hotelcancellationsurveydataservice', supportedValues: ['on', 'off'] }),
  /** Car Cancellation Reason Survey */
  carCancellationReasonSurvey: createRemoteFeatureFlag({ key: 'carcancellationreasonsurvey', supportedValues: ['on', 'off'] }),
  /**
   * Kill switch for ONLY the car cancellation-reason survey's survey_data_service integration
   * (submitting responses) — independent of the legacy `carCancellationReasonSurvey` flag, which
   * still gates whether the survey shows at all and, when this is off, still supplies the survey's
   * structure. See CarCancellationDialog.tsx.
   */
  carCancellationSurveyDataService: createRemoteFeatureFlag({ key: 'carcancellationsurveydataservice', supportedValues: ['on', 'off'] }),

  /**
   * CUG Not Verified Page
   */
  cugAccessCodes: createRemoteFeatureFlag({ key: 'cugAccessCodes', supportedValues: ['on', 'off'] }),
  /**
   * General Event
   */
  enableCreateGeneralEventRoutes: createRemoteFeatureFlag({ key: 'enablecreategeneraleventroutes', supportedValues: ['on', 'off'] }),

  /**
   * Wedding Event Creation
   */
  createWeddingDefaultThemeExperiment: createRemoteFeatureFlag({ key: 'createWeddingDefaultThemeExperiment', supportedValues: ['control', 'treatment1', 'treatment2'] }),
  createWeddingHeaderLayoutExperiment: createRemoteFeatureFlag({ key: 'createWeddingHeaderLayoutExperiment', supportedValues: ['on', 'off'] }),
  createWeddingApplyMonogramInitials: createRemoteFeatureFlag({ key: 'createWeddingApplyMonogramInitials', supportedValues: ['on', 'off'] }),
  /**
   * i18n
   */
  joyWebTranslationsEnabled: createRemoteFeatureFlag({ key: 'joywebtranslations', supportedValues: ['on', 'off'] }),
  /*
   * General event and joy pro feature flags
   */
  generalEventCategoryConfig: createRemoteFeatureFlag({ key: 'generaleventcategoryconfig', supportedValues: ['on', 'off'] }),
  /**
   * Sanitize string
   */
  nuiteeQueryStringSanitization: createRemoteFeatureFlag({ key: 'nuiteeQueryStringSanitization', supportedValues: ['on', 'off'] }),
  /*
   * User consent feature flags
   */
  dayOfLeadGenSurveyCompleted: createRemoteFeatureFlag({ key: 'dayOfLeadGenSurveyCompleted', supportedValues: ['on', 'off'] }),
  enablePostRsvpHotelBookReminder: createRemoteFeatureFlag({ key: 'enablePostRsvpHotelBookReminder', supportedValues: ['on', 'off'] }),
  expandedMapAnnouncementSeen: createRemoteFeatureFlag({ key: 'expandedMapAnnouncementSeen', supportedValues: ['on', 'off'] }),
  honeymoonAnnouncementSeen: createRemoteFeatureFlag({ key: 'honeymoonAnnouncementSeen', supportedValues: ['on', 'off'] }),
  honeymoonLeadGenSurveyCompleted: createRemoteFeatureFlag({ key: 'honeymoonLeadGenSurveyCompleted', supportedValues: ['on', 'off'] }),
  isAutoPopulationDone: createRemoteFeatureFlag({ key: 'isAutoPopulationDone', supportedValues: ['on', 'off'] }),
  scheduleOptOutAddToCalendar: createRemoteFeatureFlag({ key: 'scheduleOptOutAddToCalendar', supportedValues: ['on', 'off'] }),
  scheduleOptOutDirections: createRemoteFeatureFlag({ key: 'scheduleOptOutDirections', supportedValues: ['on', 'off'] }),
  scheduleOptOutWhereToStayLink: createRemoteFeatureFlag({ key: 'scheduleOptOutWhereToStayLink', supportedValues: ['on', 'off'] }),
  showAiRecommendationsFeedbackDialog: createRemoteFeatureFlag({ key: 'showAiRecommendationsFeedbackDialog', supportedValues: ['on', 'off'] }),
  showAutoPopulationCompletedDialog: createRemoteFeatureFlag({ key: 'showAutoPopulationCompletedDialog', supportedValues: ['on', 'off'] }),
  showGuestsNearbyHotels: createRemoteFeatureFlag({ key: 'showGuestsNearbyHotels', supportedValues: ['on', 'off'] }),
  // Default on so guests see booking links unless couples opt out.
  showBookingLinksOnRegistryPurchaseConfirmation: createRemoteFeatureFlag({
    key: 'showBookingLinksOnRegistryPurchaseConfirmation',
    supportedValues: ['on', 'off'],
    defaultValue: 'on',
  }),
  showExploreMoreStaysOnGuestSite: createRemoteFeatureFlag({ key: 'showExploreMoreStaysOnGuestSite', supportedValues: ['on', 'off'], defaultValue: 'on' }),
  showMothersDayDashboardModal: createRemoteFeatureFlag({ key: 'showMothersDayDashboardModal', supportedValues: ['on', 'off'] }),
  showStayAreasOnGuestSite: createRemoteFeatureFlag({ key: 'showStayAreasOnGuestSite', supportedValues: ['on', 'off'], defaultValue: 'on' }),
  showValentinesDayDialog: createRemoteFeatureFlag({ key: 'showValentinesDayDialog', supportedValues: ['on', 'off'] }),
  thingsToDoAnnouncementSeen: createRemoteFeatureFlag({ key: 'thingsToDoAnnouncementSeen', supportedValues: ['on', 'off'] }),
  websiteAllowHotelLinkIntercept: createRemoteFeatureFlag({ key: 'websiteAllowHotelLinkIntercept', supportedValues: ['on', 'off'], defaultValue: 'on' }),
  websiteOptOutTripProfit: createRemoteFeatureFlag({ key: 'websiteOptOutTripProfit', supportedValues: ['on', 'off'] }),
  /*
   * Admin RSVP feature flags
   */
  adminRSVPV2Enabled: createRemoteFeatureFlag({ key: 'adminRSVPV2Enabled', supportedValues: ['on', 'off'] }),
  // Kill switch for the redesigned ("beta") RSVP Responses page. Defaults to 'on' (100% rollout) —
  // when on, admins land on the redesigned page by default and can opt back into the classic page;
  // flip to 'off' in Amplitude to force everyone onto the classic page and hide the switch/badge.
  // See the `rsvpResponses` entry in shared/components/ExperienceSwitch/experiences.constants.ts.
  rsvpResponsesBetaEnabled: createRemoteFeatureFlag({ key: 'rsvpResponsesBetaEnabled', supportedValues: ['on', 'off'], defaultValue: 'on' }),
  /*
   * Guided Moments
   */
  joyGuidedMoments: createRemoteFeatureFlag({ key: 'joyGuidedMoments', supportedValues: ['on', 'off'] }),
  /*
   * Joy Pro
   */
  joyProExposeCarbon: createRemoteFeatureFlag({ key: 'joyproexposecarbon', supportedValues: ['on', 'off'] }),
  joyProRegistrationV2EnableGroupQuestions: createRemoteFeatureFlag({ key: 'joyproregistrationv2enablegroupquestions', supportedValues: ['on', 'off'] }),
  // Attendance question branching (RSVP-29): the builder control on the attendance question and the
  // guest engine's reading of `settings.attendanceBranching`. Off = today's fixed attendance path.
  joyProRegistrationV2EnableAttendanceBranching: createRemoteFeatureFlag({ key: 'joyproregistrationv2enableattendancebranching', supportedValues: ['on', 'off'] }),
  // Post-RSVP event notifications (RSVP-30): the "get event notifications" step between a v2
  // registration submission and its confirmation. Off = straight to today's confirmation.
  joyProRegistrationV2EnablePostRsvp: createRemoteFeatureFlag({ key: 'joyproregistrationv2enablepostrsvp', supportedValues: ['on', 'off'] }),
  joyProGuestIdentificationDialog: createRemoteFeatureFlag({ key: 'joyproguestidentificationdialog', supportedValues: ['on', 'off'] }),
  // Guest-site language selector: admin "Languages your guests can choose" multi-select + guest header picker.
  guestSiteLanguageSelectorEnabled: createRemoteFeatureFlag({ key: 'guestsitelanguageselectorenabled', supportedValues: ['on', 'off'] }),
  // Time format setting: admin picks 12-hour / 24-hour / automatic for the times shown on the website.
  clockFormatSettingEnabled: createRemoteFeatureFlag({ key: 'clockformatsettingenabled', supportedValues: ['on', 'off'] }),
  // Settings › Language & Currency nav entry. The route itself is always registered so a direct link never 404s.
  languageCurrencySettingsEnabled: createRemoteFeatureFlag({ key: 'languagecurrencysettingsenabled', supportedValues: ['on', 'off'] }),
  /**
   * Wedding Party List Circle Avatars
   */
  weddingPartyListCircleAvatars: createRemoteFeatureFlag({ key: 'weddingPartyListCircleAvatars', supportedValues: ['on', 'off'] }),
  /**
   * Exclude custom (API-created) VIP members from the legacy wedding party page (PRNT-4424).
   * When on, the legacy VIP page queries request Firebase-sourced VIPs only.
   */
  excludeCustomVipsFromLegacyPage: createRemoteFeatureFlag({ key: 'excludecustomvipsfromlegacypage', supportedValues: ['on', 'off'] }),
  /**
   * Guest List V2
   */
  useDirectGuestListV2: createRemoteFeatureFlag({ key: 'useDirectGuestListV2', supportedValues: ['on', 'off'] }),

  /**
   * Custom Page ItemList Integration
   * Enables the new ItemList-based component list in custom page editor.
   * @see doc/plans/item-list-integration/implementation-plan.md
   */
  customPageItemListEnabled: createRemoteFeatureFlag({ key: 'customPageItemListEnabled', supportedValues: ['on', 'off'] }),

  /**
   * Multi-day event date (PRNT-4321)
   * Gates the "Date range…" option in the EventDetails block's date-format selector and the
   * range/custom-text rendering on guest surfaces. Amplitude key is lowercase per convention.
   */
  websiteMultiDayEventDateEnabled: createRemoteFeatureFlag({ key: 'websitemultidayeventdateenabled', supportedValues: ['on', 'off'] }),

  /**
   * Group Messaging — SMS Channel
   * Gates whether SMS is available as a delivery channel (geo-targeting via Amplitude).
   * Separate from the `useGroupMessaging` event flag which is the feature kill switch.
   */
  smsChannelEnabled: createRemoteFeatureFlag({ key: 'smschannelenabled', supportedValues: ['on', 'off'] }),

  /**
   * Group Messaging — MMS (image-on-SMS)
   * Gates whether hosts can attach an image to SMS. Evaluated only after SMS is enabled
   * (see `useIsMmsEnabled`); the per-event `enableMmsOverride` flag supersedes this value.
   */
  allowMms: createRemoteFeatureFlag({ key: 'allowmms', supportedValues: ['on', 'off'] }),

  /**
   * Registration Matching Option
   * Enables the option to match the registration form to the design of the website.
   */
  registrationFormMatchingWebsite: createBooleanFeatureFlag('registrationFormMatchingWebsite'),

  /**
   * Kill switch for the WYSIWYG message composer — the block-canvas editor and its confirm
   * screen, the SMS bubble composer, and the second delivery channel that comes with them.
   * `treatment` is on. Off, `useExperienceVersion` forces every admin to the classic composer
   * regardless of their stored preference, and a WYSIWYG-authored draft opens on
   * `DraftEditorUnavailable` rather than in an editor that would flatten its block list.
   */
  messageWysiwygEditor: createRemoteFeatureFlag({
    key: 'messagewysiwygeditor',
    supportedValues: ['control', 'treatment'],
  }),

  /**
   * Gates the honeymoon cash fund success modal that shows after creating a cash fund.
   * When enabled, shows a honeymoon-themed success screen with destination browsing CTA.
   */

  /**
   * C14-278: kill switch for the auth-domain rollout. Variants carry a `payload.domain`
   * which is consumed by `useResolveAuthClientDomain` (see `useAuthClient.ts`).
   * When the flag is missing or returns no payload, the hook falls back to the env-correct
   * proxy domain via `getAuthDomain(joyEnvironment)`.
   *
   * Amplitude: prod project 142907, dev project 142658.
   */
  authDomainClients: createRemoteFeatureFlag('auth-domain-clients'),

  registryInstantPayoutEnabled: createRemoteFeatureFlag('registryInstantPayoutEnabled'),

  /**
   * Gates the visual style showcase on public stationery gallery pages
   * (save-the-date and invitation). Shows style category thumbnails
   * (Botanical, Floral, etc.) that filter the gallery.
   */
  printStyleShowcaseEnabled: createRemoteFeatureFlag({ key: 'printstyleshowcaseenabled', supportedValues: ['on', 'off'] }),
  /** Gates the postcard recipient-addressing step in the postcard customizer flow (PRNT-4836). */
  printPostcardRecipientsEnabled: createRemoteFeatureFlag({ key: 'printpostcardrecipientsenabled', supportedValues: ['on', 'off'] }),

  dashboardPhotoUploadCta: createRemoteFeatureFlag({ key: 'dashboardphotouploadcta', supportedValues: ['on', 'off'] }),
  /**
   * Dashboard right rail experiment: replaces the Website/Invitations tabs with one composed
   * "suite" (live site in a tablet frame + matching paper invitation + digital save-the-date
   * in a phone frame). Treatment ignores `printStudioOnDashboard`; not applied in compact /
   * site-preview mode.
   */
  dashboardSuitePanelExperiment: createRemoteFeatureFlag({ key: 'dashboardsuitepanelexperiment', supportedValues: ['control', 'treatment'] }),
  /**
   * Shows a "7x better deliverability" stat on the text delivery option
   * in the e-card checkout. Targeted to US events via Amplitude segments.
   */
  ecardSmsDeliveryStat: createRemoteFeatureFlag({ key: 'ecardsmsdeliverystat', supportedValues: ['on', 'off'] }),

  /**
   * Tighter zoom & reduced padding on the accommodations static map.
   * Fixes bunched pins with excess whitespace by reducing fitBounds padding
   * and using Math.round instead of Math.floor for zoom calculation.
   */
  accommsMapTighterZoom: createRemoteFeatureFlag({ key: 'accommsmaptighterzoom', supportedValues: ['on', 'off'] }),

  /**
   * PRNT-4778 / PRNT-4780: the one switch for map styling on the guest site.
   *
   * Off renders Google's default basemap and red pin on both map surfaces --
   * the schedule's venue maps and the accommodations map -- and hides the
   * designer's style picker, which has nothing to set while the guest site is
   * not rendering it.
   *
   * Deliberately one flag rather than one per surface: both go through
   * `useEventMapTheme` into the same builders and cannot render differently for
   * the same event, so a per-surface split staged code that had no way to
   * diverge. Which skin they wear is the couple's `eventDesign.mapStyle`, not a
   * flag -- a setting within the feature rather than a way to turn it off.
   */
  eventMapTheming: createRemoteFeatureFlag({ key: 'eventmaptheming', supportedValues: ['on', 'off'] }),

  /**
   * A/B test for mini-getaway banner visibility on accommodations.
   * Control: no banner. Treatment: "Turn the celebration into a mini-getaway. Add a night or two."
   */
  miniGetawayBannerCopyExperiment: createRemoteFeatureFlag({ key: 'minigetawaybannercopyexperiment', supportedValues: ['control', 'treatment'], defaultValue: 'control' }),
} as const;

export type FeatureFlags = typeof FEATURE_FLAG_VALUES;
